





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Candidates, PageOption, Headers } from '@/@types/LibraryComponent';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon,
  },
})
export default class CandidateNotCompatible extends Vue {
  private notCompatibleCandidates: Array<Candidates> = require('@/repository/mock/dummyData/recruitment/candidates.json')
    .notCompatibleCandidates;

  @Prop() private pageOption!: PageOption;
  @Prop() private headers!: Headers;
}
